import React from 'react';
import styled from 'styled-components';

function MultiSelectFilter({question, filter, onChange, validations}) {
  return (
    <>
      {[...question.questionOptions].sort((a, b) => a.order - b.order).map(option => (
        <CheckboxInput key={option.value}>
          <input type="checkbox"
            checked={filter.values.some(value => value === option.value)}
            onChange={e => {
              const isChecked = e.target.checked;

              if (isChecked) {
                onChange({...filter, values: [...filter.values, option.value]});
              }
              else {
                onChange({...filter, values: filter.values.filter(value => value !== option.value)})
              }
            }}
          />
          {option.value}
        </CheckboxInput>
      ))}
      {validations.length > 0 && (
        <InvalidText>{validations[0]}</InvalidText>
      )}
    </>
  );
}

MultiSelectFilter.validate = filter => {
  if (filter.values.length < 1) {
    return ['Please choose at least one option'];
  }

  return [];
};

MultiSelectFilter.operators = [
  'CONTAIN'
];

const CheckboxInput = styled.label`
  display: block;
  margin-top: 0.5rem;
  
  input {
    margin-right: 0.5rem;
  }
`;

const InvalidText = styled.small`
  display: block;
  font-size: 0.875rem;
  color: #dc3545;
  margin-top: 0.5rem;
`;

export default MultiSelectFilter;